export var SHOW_ALL = 'SHOW_ALL';
export var SHOW_PARENT = 'SHOW_PARENT';
export var SHOW_CHILD = 'SHOW_CHILD';


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-tree-select@1.12.3@rc-tree-select/es/strategies.js
// module id = 168
// module chunks = 0